var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMissed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5125 15.6607L16.9512 18.1557C17.199 18.3356 17.5409 18.3089 17.7577 18.0926L19.8179 16.0372C20.0093 15.8447 20.0548 15.5507 19.9306 15.3093C18.3504 12.1965 14.5017 9.99939 10.0004 9.99939C5.49897 9.99939 1.65029 12.1965 0.0700676 15.3093C-0.0549682 15.551 -0.00968206 15.8457 0.182128 16.0386L2.24232 18.0926C2.45915 18.3089 2.80097 18.3356 3.04881 18.1557L6.48751 15.6607C6.6102 15.5716 6.69605 15.4408 6.72887 15.2928L7.14264 13.4226C7.20459 13.1504 7.41379 12.9359 7.68432 12.8671C9.20244 12.48 10.7934 12.48 12.3116 12.8671C12.5821 12.9358 12.7912 13.1504 12.8529 13.4226L13.2667 15.2928C13.3006 15.4415 13.3881 15.5724 13.5125 15.6607V15.6607Z",
    fill: "#EC0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2413 0L11.2738 0.663053L13.1947 2.58394L9.95873 5.81991L4.48122 0.950963C4.20582 0.699963 3.81671 0.616479 3.46259 0.732414C3.10847 0.848349 2.84406 1.14578 2.77043 1.51105C2.69679 1.87632 2.8253 2.25297 3.10684 2.49705L9.31327 8.01388C9.7226 8.37765 10.3445 8.35936 10.7318 7.97216L14.6573 4.04659L16.5782 5.96748L17.2413 0Z",
    fill: "#EC0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissed);
export default __webpack_public_path__ + "static/media/missed.d288cec4.svg";
export { ForwardRef as ReactComponent };